import React, { useEffect, useCallback } from 'react';
import { Box, Typography, Button } from '@mui/material';
import confetti from 'canvas-confetti';
import { useTranslation } from 'react-i18next';

const OnboardingCelebration = ({ onDismiss }) => {
  const { t } = useTranslation();

  const fireConfetti = useCallback(() => {
    const gold = '#c9a96e';
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };

    confetti({ ...defaults, particleCount: 50, origin: { x: 0.3, y: 0.5 }, colors: [gold, '#fff', '#d4b97e'] });
    confetti({ ...defaults, particleCount: 50, origin: { x: 0.7, y: 0.5 }, colors: [gold, '#fff', '#d4b97e'] });

    setTimeout(() => {
      confetti({ ...defaults, particleCount: 30, origin: { x: 0.5, y: 0.3 }, colors: [gold, '#fff'] });
    }, 300);
  }, []);

  useEffect(() => {
    fireConfetti();
    const timer = setTimeout(onDismiss, 5000);
    return () => clearTimeout(timer);
  }, [fireConfetti, onDismiss]);

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 9998,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'rgba(0,0,0,0.4)',
        backdropFilter: 'blur(4px)',
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          p: 5,
          borderRadius: '16px',
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          maxWidth: 420,
          mx: 2,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontWeight: 600,
            mb: 1.5,
            color: '#c9a96e',
          }}
        >
          {t('onboarding_checklist.celebration_title', "You're all set!")}
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3 }}>
          {t(
            'onboarding_checklist.celebration_message',
            "You've completed all guides. Lawis is fully at your service."
          )}
        </Typography>
        <Button
          onClick={onDismiss}
          sx={{
            bgcolor: '#c9a96e',
            color: '#1c1917',
            fontWeight: 600,
            textTransform: 'none',
            px: 4,
            py: 1,
            borderRadius: '8px',
            fontSize: 14,
            '&:hover': { bgcolor: '#b8955a' },
          }}
        >
          {t('onboarding_checklist.celebration_cta', 'Get Started')}
        </Button>
      </Box>
    </Box>
  );
};

export default OnboardingCelebration;
